document.addEventListener('turbolinks:load', function () {
    if ($('#new-plan-review-form').length === 0) {
        return false
    }

    $('#plan-review-form textarea').each(function () {
        textAreaAdjust($(this))
    })

    $(document).on('keyup', '#plan-review-form textarea', function () {
        textAreaAdjust($(this))
    })

    // adjust textarea height
    function textAreaAdjust(element) {
        element.height('1')
        element.height(element.prop("scrollHeight") + 20)
    }

    // codes dropdown: multi-select of the city's adopted codes
    if ($.fn.select2) {
        // closeOnSelect: false keeps the typed text after a pick; clear it so the next code starts fresh
        $('#plan_review_based_on_codes').select2({ width: '100%', placeholder: 'Select', closeOnSelect: false, dropdownCssClass: 'adopted-codes-dropdown' })
            .on('select2:select', function () {
                $(this).data('select2').$container.find('.select2-search__field').val('').trigger('input')
            })
    }

    // show dropdown on review summary section when select option is clicked
    $('.select-option').on('click', function (e) {
        e.preventDefault();
        $(this).parent().find('.select-dropdown').removeClass('d-none')
    })

    $(document).on('click', function (e) {
        var containers = $(".select-dropdown");
        // when select dropdown menu is displayed
        // dropdown menu should close when clicked on anything except select option and dropdown menu and its children

        containers.each(function () {
            var container = $(this)
            var selectOption = container.parent().find('.select-option')
            if (!container.hasClass('d-none') && !container.is(e.target) && !selectOption.is(e.target) && selectOption.has(e.target).length === 0 && container.has(e.target).length === 0) {
                container.addClass('d-none');
                $('.options').addClass('d-none');
            }
        })
    })

    // add selected checkbox and radio button to UI
    $('.select-dropdown').each(function () {
        var dropdownContainer = $(this)

        addSelectedCheckbox(dropdownContainer)
        addSelectedRadio(dropdownContainer)
    })

    function addSelectedCheckbox(dropdownContainer) {
        dropdownContainer.find('.custom-checkbox').on('change', function () {
            var checkbox = $(this)
            var checkboxValue = checkbox.val();
            var parameterizeValue = parameterizeString(checkboxValue)
            var selectedLabelId = 'label-' + parameterizeValue
            let selectedOptions = $('.selected-disciplined-reviewed')
            let selectText = selectedOptions.parent().find('.select-text')
            let otherDisciplinesReviewedSection = $(this).parent().siblings('.other-disciplines-reviewed')

            if (checkbox.is(':checked')) {
                if (checkboxValue === 'Other') {
                    $(otherDisciplinesReviewedSection).removeClass('d-none')
                    $("html, body").animate({ scrollTop: $(document).height() }, "slow");
                }
                let optionTemplate = selectedOptions.find('.option')[0];
                let newOption = optionTemplate.cloneNode('true');
                let selectedOptionName = checkbox.parent().find('label').html();
                $(newOption).find('.name').html(selectedOptionName);
                $(newOption).attr('id', selectedLabelId)
                selectedOptions.removeClass('d-none');
                selectedOptions.append(newOption);
                selectText.addClass('d-none')
            } else {
                if (checkboxValue === 'Other') {
                    $(otherDisciplinesReviewedSection).addClass('d-none')
                    $(otherDisciplinesReviewedSection).find('.other-disciplines-reviewed-value').val('')
                }
                $(`#${selectedLabelId}`).remove();
                if (dropdownContainer.find("input:checkbox:checked").length === 0) {
                    selectText.removeClass('d-none')
                }
            }
        })
        dropdownContainer.find('.custom-checkbox').trigger('change')
    }

    $('.other-disciplines-reviewed-value').on('change', function () {
        let selectedLabelId = 'label-other'
        $(`#${selectedLabelId}`).remove();
        let selectedOptions = $('.selected-disciplined-reviewed')
        let selectText = selectedOptions.parent().find('.select-text')
        let optionTemplate = selectedOptions.find('.option')[0];
        let newOption = optionTemplate.cloneNode('true');
        let selectedOptionName = $(this).val();
        $(newOption).find('.name').html(selectedOptionName);
        $(newOption).attr('id', selectedLabelId)
        selectedOptions.removeClass('d-none');
        selectedOptions.append(newOption);
        selectText.addClass('d-none')
    })

    function addSelectedRadio(dropdownContainer) {
        dropdownContainer.find('.custom-radio').on('change', function () {
            var radio = $(this)
            var radioValue = radio.val();
            var parameterizeValue = parameterizeString(radioValue)
            var selectedLabelId = 'label-' + parameterizeValue
            let selectedOptions = $('.selected-plan-review-status')
            let selectText = selectedOptions.parent().find('.select-text')

            if (radio.is(':checked')) {
                selectedOptions.children().remove()
                let newOption = document.createElement('span');
                let selectedOptionName = radio.parent().find('label').html();
                $(newOption).addClass('name');
                $(newOption).html(selectedOptionName);
                $(newOption).attr('id', selectedLabelId)
                selectedOptions.removeClass('d-none');
                selectedOptions.append(newOption);
                selectText.addClass('d-none')

                let backgroundColor = radio.parent().parent().find('.color-indicator').css('background-color')
                $(newOption).css('background-color', backgroundColor)

                activate('.publish-report-btn .publish-report-link');
                activate('.publish-report-btn .confirm-and-publish-report');
            } else {
                $(`#${selectedLabelId}`).remove();
            }
        })
        if ($('.plan_reviews.edit, .plan_reviews.update').length !== 0) {
            dropdownContainer.find('.custom-radio').trigger('change')
        }
    }

    function activate(selector) {
        const el = $(selector);
        if (el.length) el.removeClass('disabled').addClass('active');
    }

    function parameterizeString(string) {
        return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    }

    if ($('.tab-container.comments').length > 0) {
        let startSn = null;

        // drag and drop plan review comments starts here
        Sortable.create(sortableList, {
            handle: '.handle-drag',
            onStart: function () {
                const $first = $('#sortableList .nested-fields:visible').first();
                startSn = parseInt($first.find('.sn').text());
            },
            onEnd: function (evt) {
                resetCommentOrder()
                resetSerialNumbers(startSn)
            },
            animation: 150,
            dragClass: 'drag-item',
            ghostClass: 'drag-background',
            draggable: ".nested-fields"
        });
        // drag and drop plan review comments ends here
    }

    function resetCommentOrder() {
        const items = $('#sortableList .nested-fields:visible');
        items.each(function (index) {
            $(this).find('.record-position').val(index + 1)
        })
    }

    function resetSerialNumbers(start) {
        if (start == null) return;

        const items = $('#sortableList .nested-fields:visible');
        if (!items.length) return;

        items.each(function (index) {
            $(this).find('.sn').text((start + index) + '.')
        });
    }

    // calculate icc valuation starts here
    var iccValuationRow = $('.icc-valuation-field')

    $(document).on('change', '#plan_review_type_of_construction', function () {
        var occupancy = $('#plan_review_occupancy').val()
        var projectIccValuationRows = $('.project-icc-valuation-field') // this icc valuation is present during mixed uses only
        var value = $(this).val()
        if (value === 'New Construction') {
            if (occupancy === "Mixed Uses") {
                $(projectIccValuationRows).each(function () {
                    $(this).removeClass('d-none')
                })
            } else {
                $(iccValuationRow).removeClass('d-none')
            }
        } else {
            if (occupancy === "Mixed Uses") {
                $(projectIccValuationRows).each(function () {
                    $(this).addClass('d-none')
                    $(this).find('input').val('')
                })
            } else {
                $(iccValuationRow).addClass('d-none')
                $(iccValuationRow).find('input').val('')
            }
        }
    })

    $(document).on('change', '.icc_valuation_trigger', function() {
        calculateIccValuation()
    })

    function calculateIccValuation() {
        var squareFeet = $('#plan_review_total_sq_ft').val()
        var occupancy = $('#plan_review_occupancy').val()
        var constructionType = $('#plan_review_construction_type').val()
        var typeOfConstruction = $('#plan_review_type_of_construction').val()
        var iccValuation = $('#plan_review_project_valuation')

        if (typeOfConstruction === 'New Construction') {
            if (occupancy !== "Mixed Uses") {
                setIccValuation(squareFeet, occupancy, constructionType, iccValuation)
            }
        }
    }

    $(document).on('change','.mixed_use_icc_valuation_trigger', function() {
        var typeOfConstruction = $('#plan_review_type_of_construction').val()
        var occupancy = $('#plan_review_occupancy').val()
        if (typeOfConstruction === 'New Construction' && occupancy === "Mixed Uses") {
            var nestedFields = $(this).closest('.nested-fields')
            calculateIccValuationForMixedUses(nestedFields)
        }
    })

    function calculateIccValuationForMixedUses(nestedFields) {
        var squareFeet = $(nestedFields).find('.sq-ft').val()
        var occupancy = $(nestedFields).find('.occupancy').val()
        var constructionType = $(nestedFields).find('.construction-type').val()
        var projectIccValuation = $(nestedFields).find('.project-icc-valuation')
        setIccValuation(squareFeet, occupancy, constructionType, projectIccValuation)
    }

    function setIccValuation(squareFeet, occupancy, constructionType, iccValuationField) {
        if (squareFeet !== '' && occupancy !== '' && constructionType !== '') {
            $.ajax({
                url: "/calculate_icc_valuation",
                data: {
                    square_feet: squareFeet,
                    occupancy: occupancy,
                    construction_type: constructionType
                },
                method: 'GET'
            }).done(function (res) {
                if (res.error) {
                    console.log(res.error)
                } else {
                    var valuation = res.valuation
                    if (valuation && valuation > 0) {
                        $(iccValuationField).val(formatWithCommasAndDecimals(valuation.toString()))
                    }
                }
            }).fail(function (res) {
                console.log('Something went wrong')
            });
        }
    }
    // calculate icc valuation ends here

    // mixed uses starts here
    var occupanciesSection = $('.occupancies-section')
    var constructionTypeSection = $('.constructionTypeSection')
    var projectIccValuationSection = $('.projectIccValuationSection')
    var sqFtSection = $('.sqFtSection')
    $(document).on('change', '#plan_review_occupancy', function () {
        var value = $(this).val()
        var typeOfConstruction = $('#plan_review_type_of_construction').val()
        if (value === 'Mixed Uses') {
            $(occupanciesSection).removeClass('d-none')
            $(constructionTypeSection).addClass('d-none')
            $(projectIccValuationSection).addClass('d-none')
            $(sqFtSection).addClass('d-none')

            if (typeOfConstruction === 'New Construction') {
                var projectIccValuationRows = $('.project-icc-valuation-field') // this icc valuation is present during mixed uses only
                $(projectIccValuationRows).each(function () {
                    $(this).removeClass('d-none')
                })
            }
        } else {
            $(occupanciesSection).addClass('d-none')
            $(constructionTypeSection).removeClass('d-none')
            $(sqFtSection).removeClass('d-none')

            if (typeOfConstruction === 'New Construction') {
                $(projectIccValuationSection).removeClass('d-none')
            }
        }
    })

    // mixed uses ends here

    // add more occupancies start here
    $('.occupancies-section')
        .on('cocoon:before-insert', function(e, insertedItem) {
            var typeOfConstruction = $('#plan_review_type_of_construction').val()
            if (typeOfConstruction === 'New Construction') {
                insertedItem.find('.project-icc-valuation-field').removeClass('d-none')
            } else {
                insertedItem.find('.project-icc-valuation-field').addClass('d-none')
            }
        })
    // add more occupancies end here

    // format number fields start here

    let $numberFormatting = $(".number_formatting");

    // As user types, auto-format
    $(document).on("input", '.number_formatting', function () {
        let input = this;
        let start = input.selectionStart;
        let beforeLength = input.value.length;

        let formatted = formatWithCommasAndDecimals(input.value);
        input.value = formatted;

        let afterLength = formatted.length;
        let diff = afterLength - beforeLength;

        // Restore cursor position (handles typing and trailing decimal)
        input.selectionStart = input.selectionEnd = start + diff;
    });

    // Function to format with commas while keeping decimals
    function formatWithCommasAndDecimals(value) {
        if (!value) return "";

        // Check if user is typing a trailing decimal (e.g., "123.")
        let hasTrailingDot = /\.$/.test(value);

        // Remove all commas
        let clean = value.replace(/,/g, "");

        // Split into integer and decimal parts
        let parts = clean.split(".");
        let integerPart = parts[0].replace(/\D/g, ""); // keep only digits
        let decimalPart = parts[1] ? "." + parts[1].replace(/\D/g, "") : "";

        // Format integer with commas
        integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        // If user typed trailing ".", keep it
        if (hasTrailingDot && !decimalPart) {
            return integerPart + ".";
        }

        return integerPart + decimalPart;
    }

    // Initial formatting
    $numberFormatting.each(function () {
        let formattedValue = formatWithCommasAndDecimals(this.value);
        this.value = formattedValue;
    })

    // format number fields end here

    // insert-comment starts here
    $(document).off('click', '.insert-comment').on('click', '.insert-comment', function (e) {
        e.preventDefault()
        $('.add-new-review-comment-btn').click()
    })

    $('#sortableList')
        .on('cocoon:before-insert', function(e, insertedItem) {
            var nestedFields = $('#sortableList .nested-fields:visible')
            var lastSnNumber = $(nestedFields).last().find('.sn').text()
            if (lastSnNumber !== '') {
                insertedItem.find('.sn').text(parseInt(lastSnNumber) + 1 + '.')
            }
        })

    $('#sortableList')
        .on('cocoon:after-insert', function(e, insertedItem) {
            resetCommentOrder()
        })
    // insert-comment ends here

    // remove-comment starts here
    let firstSn = null;

    const $first = $('#sortableList .nested-fields:visible').first();
    if ($first.length) {
        firstSn = parseInt($first.find('.sn').text());
    }
    $('#sortableList')
        .on('cocoon:after-remove', function(e, removedItem) {
            resetCommentOrder()
            resetSerialNumbers(firstSn)
        })
    // remove-comment ends here

    // publish report and verify report action starts here
    $(document).off('click', '.publish-report-link').on('click', '.publish-report-link', function (e) {
        e.preventDefault()
        $(this).attr('disabled', true)
        $('#publish_report_action').val('publish')
        submitForm()
    })

    $(document).off('click', '.verify-and-publish-report-link').on('click', '.verify-and-publish-report-link', function (e) {
        e.preventDefault()
        $(this).attr('disabled', true)
        $('#publish_report_action').val('verify_and_publish')
        submitForm()
    })

    function submitForm() {
        let form = document.querySelector('#plan-review-form');
        form.requestSubmit();   // like clicking a submit button
    }
    // publish report and verify report action ends here
});